var _ellipse, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _polygon, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse2, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse3, _path21, _path22, _ellipse4, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _ellipse5, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _polygon2, _polygon3, _polygon4, _polygon5, _path62, _polygon6, _polygon7, _polygon8, _path63, _path64, _path65, _path66, _path67, _path68, _ellipse6, _path69, _path70, _ellipse7, _path71, _path72, _path73, _path74, _path75, _path76, _circle, _path77, _path78, _path79, _path80, _polygon9, _polygon10, _path81, _circle2, _path82, _path83, _path84, _path85, _path86, _ellipse8, _path87, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBossGivingInstructions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.87,
    cy: 595.15,
    rx: 387.27,
    ry: 56.5,
    fill: "#a9cef4"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 416.87,
    cy: 595.15,
    rx: 387.27,
    ry: 56.5,
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.24,518.84s-207,17.81-204.08-146c0,0-11.47-128.36,82.77-204.89a190.12,190.12,0,0,1,80.5-38c23.56-5,63.8-16,105.27-38.28,0,0,179.21-129,371.93-10.14,0,0,144.91,94.16,102.88,252.12,0,0-26.86,167.25-284.4,158.26C544.11,491.93,376,514.17,289.24,518.84Z",
    fill: "#a9cef4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.24,518.84s-207,17.81-204.08-146c0,0-11.47-128.36,82.77-204.89a190.12,190.12,0,0,1,80.5-38c23.56-5,63.8-16,105.27-38.28,0,0,179.21-129,371.93-10.14,0,0,144.91,94.16,102.88,252.12,0,0-26.86,167.25-284.4,158.26C544.11,491.93,376,514.17,289.24,518.84Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 364.21,
    y: 109.69,
    width: 386.17,
    height: 261.1,
    rx: 32.21,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 354.34,
    y: 118.47,
    width: 389.46,
    height: 247.94,
    rx: 32.21,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 541.94,
    y: 298.39,
    width: 131.65,
    height: 8.78,
    fill: "#a9cef4",
    opacity: 0.37
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 541.94,
    y: 313.75,
    width: 85.57,
    height: 8.78,
    fill: "#a9cef4",
    opacity: 0.37
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 541.94,
    y: 329.1,
    width: 115.19,
    height: 8.78,
    fill: "#a9cef4",
    opacity: 0.37
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 386.15,
    y: 146.99,
    width: 183.21,
    height: 118.48,
    rx: 6.46,
    fill: "#a9cef4",
    opacity: 0.37
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "558.39 237.2 415.64 237.2 415.64 156.83 416.74 156.83 416.74 236.1 558.39 236.1 558.39 237.2",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 432.23,
    y: 216.11,
    width: 4.39,
    height: 20.84,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 445.4,
    y: 212.81,
    width: 4.39,
    height: 24.14,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 505.74,
    y: 212.81,
    width: 4.39,
    height: 24.14,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 518.9,
    y: 190.87,
    width: 4.39,
    height: 46.08,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M456.37,244.63H414.6a.55.55,0,0,1,0-1.1h41.77a.55.55,0,0,1,0,1.1Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M456.37,250.11H414.6a.55.55,0,1,1,0-1.09h41.77a.55.55,0,1,1,0,1.09Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.37,255.6H414.6a.55.55,0,0,1,0-1.1h41.77a.55.55,0,0,1,0,1.1Z",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 168.3,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 178.18,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 186.95,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 195.73,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 204.51,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 212.19,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 220.96,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 403.16,
    y: 230.84,
    width: 6.03,
    height: 1.1,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.23 201.18 425.57 200.31 447.5 183.67 469.48 191.91 494.72 177.1 507.87 182.57 537.25 162.99 537.86 163.9 507.99 183.81 494.81 178.32 469.58 193.12 447.68 184.91 426.23 201.18",
    fill: "#a9cef4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.37
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "538.1 169.48 537 169.48 537 163.6 529 164.62 528.86 163.53 538.1 162.35 538.1 169.48",
    fill: "#a9cef4"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M460.31,262l39.39-3.68,6,67.51s-6.64,11.48-8,12S458,336.24,458,336.24l-3.77-16.11Z",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M515.06,565.28s.45,23.82,11.78,29.32a6.84,6.84,0,0,0,7.45-1c4.07-3.54,9.45-12.47,1.07-33Z",
    fill: "#a9cef4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M522.11,432.15,525.48,486s2.2,38.39,2.2,50.46,7.68,24.14,7.68,24.14c-1.1,12.07-9.88,13.16-9.88,13.16-4.39,1.1-7.68-3.29-9.87-6.58s2.19-18.65,2.19-18.65c-9.87-20.84-16.45-80.09-16.45-80.09-4.39-11-6.59-29.62-6.59-29.62Z",
    fill: "#f9b499"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M460.52,238.75s-4.3,11.21-8.07,15.67a63.61,63.61,0,0,1,17.08-4.31v-6.18S465.14,243.53,460.52,238.75Z",
    fill: "#21272d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M391,276.33l1.9,4s8.06-2.27,14.15-12.22l-1.47-2.46a1.35,1.35,0,0,0-2-.38l-12.2,9.39A1.35,1.35,0,0,0,391,276.33Z",
    fill: "#21272d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M469.87,580v0a1.42,1.42,0,0,1-2.83,0V569a28.67,28.67,0,0,1-8.17,8.87,19,19,0,0,1-11.19,3.6H428.94c-4.39-1.1,13.16-14.26,13.16-14.26s6.59,6.58,17.56-5.49c0,0,4.39-6.58,9.87-7.67Z",
    fill: "#a9cef4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M524.39,384v43.45a6,6,0,0,1-3.91,5.66,110.81,110.81,0,0,1-38,7.12h0a74.35,74.35,0,0,1-28-5.26,5.84,5.84,0,0,1-3.59-5.43V337.78a45.82,45.82,0,0,1,15.57-9.43,39.83,39.83,0,0,1,31.31,1.51l3.89,7.92Z",
    fill: "#21272d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M501.65,337.78,494.21,343a164.16,164.16,0,0,0,.58,27.44v0c-6.56,5.14-27.44,10.23-27.44,10.23l-.54,3.05c15.92.85,28.58-9.09,28.58-9.09v-.07c2.37,14.18,8.29,25.77,22.43,16,0,0,2.88,37.85-35.3,49.65a110.81,110.81,0,0,0,38-7.12,6,6,0,0,0,3.91-5.66V384Z",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M497.76,329.86c-9.07,5.15-20.55-.76-20.55-.76-5.48-2.19-10.82,2.55-10.82,2.55l.06-3.3A39.83,39.83,0,0,1,497.76,329.86Z",
    opacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.57,
    cy: 583.63,
    rx: 46.08,
    ry: 12.07,
    fill: "#b3b3b3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.34,486.31,259.83,577a3,3,0,0,0,2.94,2.65h6.88a3,3,0,0,0,3-3V483H253.28A3,3,0,0,0,250.34,486.31Z",
    fill: "#a7a9ac"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M202.94,343.37s-19.75,2.19-20.84,28.52c0,0-3.29,30.18,10.42,86.4,0,0,5.3,33.56,46.8,30.63l47-1.74,1.9-36.06-44.86-88Z",
    fill: "#b3b3b3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M241.16,344.53l32.54-2.81,5.22,41.3,1.91,13.66s-10.42,12-11.51,12.52-13.72-12.52-13.72-12.52Z",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M279.39,322.52s11.32-3.29,15.71,4.39l14.26,30.72V394.3l-34-19.12Z",
    fill: "#a9cef4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.92,293.27s1.14,6.21,9.91,12.8c0,0-5.55,2.33-9.91.61a4.53,4.53,0,0,0,2.23,3.77,23,23,0,0,1-11,1.64S270.89,307.9,270.92,293.27Z",
    fill: "#21272d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M700.75,587.32l-3.14,1.73a5.13,5.13,0,0,1-3.08.6c-5.73-.77-11.07,7.14-11.07,7.14a14.48,14.48,0,0,1-8.77,6.58c-20.85,7.68-25.43-3-25.43-3-4.59-5.2,11.16-11.27,11.16-11.27,6.27-.9,10.34-14.19,11.62-19.07,8.79-.46,22.39-7.81,22.39-7.81a5.9,5.9,0,0,0,1.78-1.54l8.1,21.84C704.84,584.35,702.42,586.4,700.75,587.32Z",
    fill: "#21272d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M700.75,587.32l-3.14,1.73a5.13,5.13,0,0,1-3.08.6c-5.73-.77-11.07,7.14-11.07,7.14a14.48,14.48,0,0,1-8.77,6.58c-20.85,7.68-25.43-3-25.43-3-4.59-5.2,11.16-11.27,11.16-11.27,6.27-.9,10.34-14.19,11.62-19.07,8.79-.46,22.39-7.81,22.39-7.81a5.9,5.9,0,0,0,1.78-1.54l8.1,21.84C704.84,584.35,702.42,586.4,700.75,587.32Z",
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 725.15,
    cy: 598.44,
    rx: 41.69,
    ry: 11.52,
    fill: "#a7a9ac"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M696.21,560.69a5.9,5.9,0,0,1-1.78,1.54S680.83,569.58,672,570a10,10,0,0,1-4.18-.51,3.59,3.59,0,0,1-2.22-3.54,4.82,4.82,0,0,1,1.37-3.21s2.19-2.19,0-7.68l-10.72-23.35L630.8,482.7l17.56-23-11.73-20.53s22.49-9.84,38.49-7.82L683.54,497l10.36,49a17.52,17.52,0,0,0,1.56,4.31C696.76,552.86,698.58,557.58,696.21,560.69Z",
    fill: "#a9cef4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M696.21,560.69a5.9,5.9,0,0,1-1.78,1.54S680.83,569.58,672,570a10,10,0,0,1-4.18-.51,3.59,3.59,0,0,1-2.22-3.54,4.82,4.82,0,0,1,1.37-3.21s2.19-2.19,0-7.68l-10.72-23.35L630.8,482.7l17.56-23-11.73-20.53s22.49-9.84,38.49-7.82L683.54,497l10.36,49a17.52,17.52,0,0,0,1.56,4.31C696.76,552.86,698.58,557.58,696.21,560.69Z",
    opacity: 0.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 471.45,
    cy: 220.49,
    rx: 17.28,
    ry: 23.59,
    fill: "#f9b499"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M469.53,243.93v6.18s-4.47.86-6.07,1l.59,18.77s16.62,12.41,28.6-3.67c0,0-5.21-12-5.39-18.43l-.4-16.63S481.6,245.73,469.53,243.93Z",
    fill: "#f9b499"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M469.53,243.93v4.54s16,1,17.33-17.34C486.86,231.13,481.6,245.43,469.53,243.93Z",
    fill: "#f7a48b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M407.88,266.91c-1.14,1.79-6.77,10-14.86,13.41a1.39,1.39,0,0,0-.72,1.89c3,6.19,15.81,31.4,25.46,37a7.07,7.07,0,0,0,5.44.66,36.42,36.42,0,0,0,21.1-16l2.19,82.28s2.2,0,6.59,3.29c0,0,12.06,8.78,14.26-8.77l-1.1-70.22-2.19-40.59-.59-18.77s-14.76,2.15-23.68,12.14a19.43,19.43,0,0,0-1.72,2.33c-2.9,4.45-13.36,20.13-19,22.95l-10.79-21.57A.23.23,0,0,0,407.88,266.91Z",
    fill: "#a9cef4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M439.49,308.9s-.68-24.78,3.71-36.84c0,0-2.19,20.84,0,31.81C443.2,303.87,442.36,305.15,439.49,308.9Z",
    fill: "#fff",
    opacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M454.25,254s-.87,58.22,12.14,66.14l-2.93-69A50.28,50.28,0,0,0,454.25,254Z",
    fill: "#a9cef4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M454.25,254s-.87,58.22,12.14,66.14l-2.93-69A50.28,50.28,0,0,0,454.25,254Z",
    fill: "#fff",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M499.15,379.57s-5.31-22.24-6.5-65.43V266.19l10.21-17.71s13.85.54,29.21,14.8l15.63,11.15s7.22,4.58,11.7,0l10-9a36.39,36.39,0,0,0,17.55,13.17l-20.85,23s-4.38,6.58-17.55,1.09L524.39,294s-5.49,9.87-5.49,15.36c0,0-2.19,36.2,11,53.75,0,0,9.87,11-5.48,20.85C524.39,384,501.35,403.71,499.15,379.57Z",
    fill: "#a9cef4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M502.44,355.43s9.88,8.78,23,11C525.48,366.4,498.06,367.5,502.44,355.43Z",
    fill: "#fff",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M550.29,275.66s-.67,11.76,8.11,16.14c0,0-4.58-8.91-2.84-15.42C555.56,276.38,552.06,277.08,550.29,275.66Z",
    fill: "#fff",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M492.72,316.26s8.47-.3,8-34.87l2.14-32.91-10.21,17.71Z",
    fill: "#a9cef4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M492.72,316.26s8.47-.3,8-34.87l2.14-32.91-10.21,17.71Z",
    fill: "#fff",
    opacity: 0.2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M450.88,387.88v3.76s6.88,7,10.57-.34c0,0-4,1.43-8.37-1.86Z",
    opacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M449.78,380.67s12.07-4.39,13.17-12.07C463,368.6,469.53,378.47,449.78,380.67Z",
    fill: "#fff",
    opacity: 0.2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M468.43,363.11s8.44,4.44,23.42,3.32C491.85,366.43,480.5,377.38,468.43,363.11Z",
    opacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M468.43,317s19.75,13.16,21.95,1.09Z",
    fill: "#fff",
    opacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M419.74,290.48s3.71,16.68,7,16.68c0,0,3.29,1.1,1.09-3.29Z",
    fill: "#fff",
    opacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M570.49,267l3.26-2.63L588,274.25l-2.87,3.69S576,274,570.49,267Z",
    fill: "#21272d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M575.32,265.46s13.79-14.25,17.08-13.15c0,0,1.1,2.19-2.19,8.78,0,0,1.71,1,8.54-2.24,0,0,11.21-4,12.23,1.4a1.36,1.36,0,0,1-.49,1.29l-8.15,6.51a10.19,10.19,0,0,1-5.13,2.17l-12.75,1.57Z",
    fill: "#f9b499"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M480,440.19,478.31,475c0,35.1-8.78,70.91-8.78,70.91V554c-5.48,1.09-9.87,7.67-9.87,7.67-11,12.07-17.56,5.49-17.56,5.49l14.79-20.27V458.5a19.17,19.17,0,0,0-.62-5c-2.09-7.58-1.8-18.58-1.8-18.58C464.64,439.82,480,440.19,480,440.19Z",
    fill: "#f9b499"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M723.22,600.08h0a7.5,7.5,0,0,1-7.47-6.81l-9.25-101.8h25.23l-1,101.19A7.49,7.49,0,0,1,723.22,600.08Z",
    fill: "#bcbec0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M663.71,562.78l1.92,7.68a6.19,6.19,0,0,1,.1,2.57,12.69,12.69,0,0,1-2.88,6.05c-7.68,9.09-27,9.4-27,9.4-5.6.37-3.4-9.18-2.27-13.09a5.76,5.76,0,0,0-.07-3.46c-3.86-11.83-10.82-27.13-13-31.84a9.28,9.28,0,0,0-1.17-2c-2.48-3.06-1.84-7.34-1.19-9.72a4,4,0,0,0-.7-3.51l-1.32-1.77a4.64,4.64,0,0,0-1.42-1.26c-3.15-1.78-3.15-5.67-2.87-7.89a6,6,0,0,0-.52-3.36c-11.23-23.74-11.23-50.92-11.23-50.92-4.38-23,71.71-23.08,71.71-23.08l-20.65,58.9-.51,1.48c.07,2.19,5.41,32.91,5.41,32.91C657.13,539.74,663.71,562.78,663.71,562.78Z",
    fill: "#a9cef4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M662.85,579.08a17.23,17.23,0,0,0,.86-10.81c-3.29,8.77-11,7.68-11,7.68,13.17-7.68,5.49-24.14,5.49-24.14L646.78,506a8.34,8.34,0,0,0-2.53-4.21l-9.06-8.15c-15.36-15.36-8.9-31.24-8.9-31.24l7.8,3.81,17,29.24-.51,1.48c.07,2.19,5.41,32.91,5.41,32.91,1.09,9.87,7.67,32.91,7.67,32.91l1.92,7.68a6.19,6.19,0,0,1,.1,2.57A12.69,12.69,0,0,1,662.85,579.08Z",
    opacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M637.38,538.65a76.79,76.79,0,0,1-10.66-5.89c-3.35-2.28-6.82-4.63-9.28-7.9,6.27,5.14,13.42,9,19.94,13.79Z",
    opacity: 0.2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M637.38,588.41s-.54,13.32-8.77,18.25c0,0-15.76,6.07-11.17,11.27,0,0,4.59,10.68,25.43,3a14.53,14.53,0,0,0,8.78-6.59s5.34-7.9,11.07-7.14a5,5,0,0,0,3.08-.6l3.14-1.73a4,4,0,0,0,1.92-4.69l-6.78-22.8S659.87,586.37,637.38,588.41Z",
    fill: "#21272d"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.05,
    cy: 289.74,
    rx: 18.94,
    ry: 24.99,
    transform: "translate(-89.8 114.24) rotate(-21.85)",
    fill: "#f9b499"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M232.88,275.86s17.24,14.85,21.62,1.68c0,0,15.11,8.07,21.82-4.19,0,0,2-6.34-9.36-12a3.17,3.17,0,0,1,2.9-1.32s-3.61-11-18.81-12.09c0,0-18.49-2.17-25.07,11,0,0-19.75-2.19-15.36,25.23,0,0,8.06,21.09-4.75,23.16,0,0,3.65,6.47,15.72,3.17,0,0-2.19,5.49-4.39,5.49,0,0,11,2.19,18.65-6.58,0,0,1.1,3.29-1.09,4.39,0,0,6.72.24,5.55-6.47C240.31,307.28,226.61,293.93,232.88,275.86Z",
    fill: "#21272d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M240.31,307.28s3.22,12-4.46,15.24l9.88,25.23s18.65,2.2,25.23-2.19l-3.29-21.94a13.24,13.24,0,0,1-6.49-11S251.76,317.58,240.31,307.28Z",
    fill: "#f9b499"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M240.31,307.28s5,12,22.22,10.86a24.56,24.56,0,0,1-1.35-5.56S251.35,318.38,240.31,307.28Z",
    fill: "#f7a48b"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M267.67,323.62s-2.19-2.48,0-2.89c0,0,12.07-1.87,13.16,4.35,0,0,5.49,31.45-5.48,50.1L271,345.56Z",
    fill: "#21272d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5,460.75c-8.29,14.93-24.11,9.8-31.33,6.4a27.14,27.14,0,0,1-6.83-4.6,16.23,16.23,0,0,1-4.93-7.3,17,17,0,0,1-.72-2.3h0a18.52,18.52,0,0,1-.05-8.91l6.56-27.16c-8.77-2.19-9.87-15.36-9.87-15.36l-1.13-25.78A23.18,23.18,0,0,0,203,364.65c-5.56-9.1-3.33-21.28-3.33-21.28,4.39-20.85,23.4-20.85,23.4-20.85L234.76,339l20.84,49.37s2.84,20.82,4.13,37.85c.1,1.3.18,2.58.26,3.84A65.75,65.75,0,0,1,254.5,460.75Z",
    fill: "#a9cef4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M262.18,459.66C258.89,484.89,239.32,483,239.32,483c-28-4-28.62-29.4-28.63-30.06a17,17,0,0,0,.72,2.3,16.23,16.23,0,0,0,4.93,7.3,27.14,27.14,0,0,0,6.83,4.6c7.22,3.4,23,8.53,31.33-6.4A65.75,65.75,0,0,0,260,430c-.08-1.26-.16-2.54-.26-3.84C264.94,442.09,262.18,459.66,262.18,459.66Z",
    fill: "#a9cef4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M262.18,459.66C258.89,484.89,239.32,483,239.32,483c-28-4-28.62-29.4-28.63-30.06a17,17,0,0,0,.72,2.3,16.23,16.23,0,0,0,4.93,7.3,27.14,27.14,0,0,0,6.83,4.6c7.22,3.4,23,8.53,31.33-6.4A65.75,65.75,0,0,0,260,430c-.08-1.26-.16-2.54-.26-3.84C264.94,442.09,262.18,459.66,262.18,459.66Z",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M365.72,550.78a8,8,0,0,1-3.7,5.42,39.43,39.43,0,0,1-13.28,4h0c-1.25.16-2.59.3-4,.36a2.73,2.73,0,0,1-2.85-2.37c-.52-3.82-1.21-11.17.37-15.12,0,0-21.94-34-27.43-57L305.1,462.6a6.14,6.14,0,0,0-4.73-3.74c-5.07-.79-14.54-.82-21,8a16.92,16.92,0,0,1-7.15,5.56,49.52,49.52,0,0,1-5.57,2,42.12,42.12,0,0,1-11.07,1.66s12.64-10.91,4.13-49.85l7,.47,65.71,4.44,31.81,105.34S367.14,544.65,365.72,550.78Z",
    fill: "#21272d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M266.69,474.37l0,0a42.12,42.12,0,0,1-11.07,1.66s12.64-10.91,4.13-49.85l7,.47S271.2,463.85,266.69,474.37Z",
    opacity: 0.2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M309.36,429.55s15.38,3.16,29.08,21.57l-6-20Z",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M269.86,577s12.07,6.59,21.95,3.29L313,481.52,305.1,462.6s-.89-6.42-13.68-3.59a18.81,18.81,0,0,0-12,7.83l-1.85,2.1Z",
    fill: "#21272d"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M269.86,577s12.07,6.59,21.95,3.29L313,481.52,305.1,462.6s-.89-6.42-13.68-3.59a18.81,18.81,0,0,0-12,7.83l-1.85,2.1Z",
    opacity: 0.2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M297.67,553s-7.59,26.29-22.63,26.27c0,0,10.18,3.28,16.77,1.08Z",
    opacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M387.92,581.09H368.23a3,3,0,0,1-2.82-2c-1.16-3.12-3.56-9.14-5.63-11.73A1.09,1.09,0,0,0,359,567h-3a1.09,1.09,0,0,0-1.1,1.11l.23,12.94h-3.52l-2.79-20.93h0a39.43,39.43,0,0,0,13.28-4,8,8,0,0,0,3.7-5.42h0a38.4,38.4,0,0,0,20.42,23S395.18,578.56,387.92,581.09Z",
    fill: "#a9cef4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M271.67,577.92s-10.58,20-10.58,26.55c0,0,0,15.36,6.58,13.17,0,0,15.36-4.39,17.55-16.46l4.23-20.3S282.26,582.08,271.67,577.92Z",
    fill: "#a9cef4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.66 429.55 181.75 609.96 199.21 609.96 255.6 429.55 229.66 429.55",
    fill: "#bcbec0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "630.07 429.55 677.98 609.96 660.52 609.96 604.13 429.55 630.07 429.55",
    fill: "#bcbec0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "637.7 355.43 544.41 355.43 556.25 411.93 651.65 411.38 637.7 355.43",
    fill: "#e6e6e6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "544.41 355.43 543.04 351.05 635.85 351.05 637.7 355.43 544.41 355.43",
    fill: "#a9cef4"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M543,351.05l-1.34,4.38,11.6,59.71,100,.63-1.64-4.39-95.39.55c-3.68-15.37-6.09-27.8-9.38-43.88-.4-1.93-1.55-8.81-2.2-12.07A46,46,0,0,0,543,351.05Z",
    fill: "#a9cef4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "563.02 355.43 551.03 387.88 554.78 404.88 575.56 355.43 563.02 355.43",
    fill: "#fff",
    opacity: 0.2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "595.93 355.43 578.06 411.93 592.48 411.73 610.78 355.43 595.93 355.43",
    fill: "#fff",
    opacity: 0.2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "625.79 355.43 610.78 411.62 627.51 411.93 640.99 368.6 637.7 355.43 625.79 355.43",
    fill: "#fff",
    opacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M716.53,179.9a62.67,62.67,0,0,1,2,15.91c0,33.63-26.53,60.89-59.24,60.89a58.09,58.09,0,0,1-12.87-1.44l12.95-58.52Z",
    fill: "#b3b3b3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M694.73,147a57.91,57.91,0,0,0-35.4-12.07c-25.78,0-47.7,16.92-55.85,40.53l55.93,21.29Z",
    fill: "#21272d"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M646.52,255.27c-26.56-6-46.44-30.35-46.44-59.46a62.46,62.46,0,0,1,3.39-20.35l55.94,21.28Z",
    fill: "#a9cef4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M716.51,179.86A61,61,0,0,0,694.73,147l-35.32,49.75Z",
    fill: "#ccc"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93,321.42v7.2s11-7.2,18.65-6.1V311.15l-11-1.79Z",
    fill: "#f9b499"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M733.93,321.42v5.06s10.33-3.87,13.94-8.85v-6.08l-3.52-1.75Z",
    fill: "#f7a48b"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 732.23,
    cy: 301.3,
    rx: 23.43,
    ry: 14.61,
    transform: "translate(307.78 969.72) rotate(-79.95)",
    fill: "#f9b499"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M719.63,292.22l-1.31,4.24s3.61,1.51,4.73-2.95c0,0,2.77,6.35,9.18,4.85a2.47,2.47,0,0,1,0-2.55s6.88,8.82,16.12,5.49l-7.47-13.36-8.65-4.81-9.93,3.63a13.5,13.5,0,0,0-1.48,2.3A14.58,14.58,0,0,0,719.63,292.22Z",
    fill: "#f7a48b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M723,290.71a8.71,8.71,0,0,0,7.68,4.38s-.57-3.47,1.36-3.38c0,0,5.68,11,15.87,10v16s13.48,3.79,22.26-17.05c0,0,12.07-21.94-7.68-30.72,0,0-21.94-7.68-32.91,1.1,0,0-20.85,9.87-17.55,17.55S717.47,294,723,290.71Z",
    fill: "#21272d"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 748.05,
    cy: 307.67,
    rx: 7.13,
    ry: 4.53,
    transform: "translate(235.1 933.07) rotate(-73)",
    fill: "#f9b499"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M726.25,333.49s16.45-13.16,29.62-11c0,0,10.31-1.34,8.45,5.36Z",
    fill: "#a9cef4"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M788.78,353.24l1.46-6.58a18,18,0,0,0-.39-9.69c-5.09-15.09-25.24-9-25.53-9.09s-38.07,5.61-38.07,5.61c-23-1.09-26.33,24.14-26.33,24.14s-15.36,19.75-13.17,23c0,0-7.68,3.29-6.58,15.36l-52.66,6.58v12.53h55.15Z",
    fill: "#21272d"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M686.75,380.67c-7.22,4.16-5.72,13.66-3.06,20.21.89,2.38,2,4.65,3.06,7-.72-1.06-1.38-2.15-2.07-3.23a31.76,31.76,0,0,1-4.08-10.83c-1-5,1-11.32,6.15-13.13Z",
    opacity: 0.2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M594.05,415.14h33.46v-7.28l-12-2.71a11.29,11.29,0,0,0-8.69,1.59Z",
    fill: "#f9b499"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M803.84,397.85c-.76,16.62-4,48.94-17.25,73.87,0,0-15.36,25.24-36.21,25.24H653.29a26.13,26.13,0,0,1-9.2-2.13h0A26.46,26.46,0,0,1,630.8,482.7s-15.36-24.14,7.68-31.82c0,0,3.79-2.27,13.24-3a26.9,26.9,0,0,0,20.07-11.26c.24-.34.47-.7.7-1.06a11.39,11.39,0,0,0,.79-1.1c1.26-1.94,4.18-6.94,9.49-18.65,2.77-6.09,6.18-14,10.34-24.21,0,0,17.57-64,71.43-51.72,0,0,40.54,10.49,39.52,47.06C804.06,386.9,804.16,391.07,803.84,397.85Z",
    fill: "#b3b3b3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M803.84,397.85c-.76,16.62-4,48.94-17.25,73.87,0,0-15.36,25.24-36.21,25.24H653.29a26.13,26.13,0,0,1-9.2-2.13h0s-12.18-8.84,2.08-22c0,0,5.49-7.68,20.85-6.58,0,0,40.59,4.86,59.24-37.07C726.25,429.17,742.11,365.66,803.84,397.85Z",
    fill: "#a7a9ac"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 231.47,
    cy: 294,
    r: 6.58,
    fill: "#f9b499"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M231.47,392.73a79.65,79.65,0,0,1-12.62,23.59h56l-2.19-19.64Z",
    fill: "#a9cef4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M224.88,346.58s6.43,23.12,3.76,41.77a6.15,6.15,0,0,0-5.59,4.38,9.1,9.1,0,0,1,7.32-1.09s-8.78,4.39-9.87,9.87c0,0,6.58-7.68,11-8.78,0,0,23,5.33,37.85,5.41v-2.35s-26.1-.86-38.56-7.44C230.76,388.35,232.56,358.57,224.88,346.58Z",
    fill: "#a9cef4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M224.88,346.58s6.43,23.12,3.76,41.77a6.15,6.15,0,0,0-5.59,4.38,9.1,9.1,0,0,1,7.32-1.09s-8.78,4.39-9.87,9.87c0,0,6.58-7.68,11-8.78,0,0,23,5.33,37.85,5.41v-2.35s-26.1-.86-38.56-7.44C230.76,388.35,232.56,358.57,224.88,346.58Z",
    opacity: 0.2
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85,322.52a19.15,19.15,0,0,0-12.8,0q.91,4.83,2.15,10c1.13,4.69,2.7,10.52,4.68,16.32a32.35,32.35,0,0,0,4,7.83l21.77,31.72s-3.29-28.53-9.87-40.6Z",
    fill: "#21272d"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.26 351.05 353.09 416.49 260.11 416.49 283.03 351.05 384.26 351.05",
    fill: "#a9cef4"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.26 351.05 353.09 416.49 260.11 416.49 283.03 351.05 384.26 351.05",
    fill: "#fff",
    opacity: 0.4
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M384,351.51l-31,65H277.54s69.26-25.79,106.37-65.07A.08.08,0,0,1,384,351.51Z",
    fill: "#fff",
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.4,
    cy: 363.11,
    r: 3.29,
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M682.77,415.77c-5.31,11.71-8.23,16.71-9.49,18.65H171.13a4.38,4.38,0,0,1-4.39-4.38v-9.88a4.39,4.39,0,0,1,4.39-4.39Z",
    fill: "#e6e6e6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9,217s.75,7.89,4.84,11.14A.16.16,0,0,0,455,228c-.36-1.17-1.09-4.61-.5-12.07C454.5,215.88,453.62,215.56,449.9,217Z",
    fill: "#21272d"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9,217s.75,7.89,4.84,11.14A.16.16,0,0,0,455,228c-.36-1.17-1.09-4.61-.5-12.07C454.5,215.88,453.62,215.56,449.9,217Z",
    opacity: 0.2
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M455.71,210.77a31.47,31.47,0,0,0-1.54,9.72,11.48,11.48,0,0,1,3.81-4.61s2.33,10.39,22.3-5.11c0,0,1.49,9.25,8.53,10.58l2.66-18.41-13.16-2.19Z",
    fill: "#f7a48b"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M486.75,231.46l.34,9.88c-1.1,16.45,11,35.1,11,35.1l7.68,14.27c6.58,17.55-2.75,27.42-2.75,27.42,9.33,3.29,13.72-7.68,13.72-7.68,1.09,4.39-2.2,7.68-2.2,7.68a16.69,16.69,0,0,0,6.51-2.34,12,12,0,0,0,5.33-8.06,35.08,35.08,0,0,0-11.84-33.48c-6.58-4.39-6.58-13.16-6.58-13.16,1.1-14.27-1.1-38.4-1.1-38.4-3.29-35.11-18.1-31.58-18.1-31.58-24.68-22.8-46.63,19.51-46.63,19.51-2.19,6.58,4.39,4.39,4.39,4.39,3.29,5.48,13.17-2.2,13.17-2.2s1.1,12.07,21.94-8.77c0,0,1.1,12.38,7.13,12.77C488.73,216.81,489.7,222.69,486.75,231.46Z",
    fill: "#21272d"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490.18,
    cy: 220.22,
    rx: 6.02,
    ry: 4.07,
    transform: "translate(131.24 620.14) rotate(-72.28)",
    fill: "#f9b499"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M393.14,273.35a20.55,20.55,0,0,0-6.39-5.74,17.48,17.48,0,0,0-7.25-2.26,20,20,0,0,1-5.91-1.35,3.71,3.71,0,0,1,.32-7c3-1,8.59-1.36,18.25,2.19,0,0,1.67.07-1.62-2.87,0,0-4-3.68-2.45-6.88a.33.33,0,0,1,.55-.09,17.23,17.23,0,0,0,6,4.65,9.76,9.76,0,0,1,3.79,2.62,16.62,16.62,0,0,1,3.65,9.85Z",
    fill: "#f9b499"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.45,
    cy: 202.94,
    r: 3.29,
    fill: "#a9cef4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.59,
    cy: 184.29,
    r: 3.29,
    fill: "#a9cef4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.76,
    cy: 177.71,
    r: 3.29,
    fill: "#a9cef4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.93,
    cy: 183.19,
    r: 3.29,
    fill: "#a9cef4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBossGivingInstructions);
export default __webpack_public_path__ + "static/media/bossGivingInstructions.a87e56d1eadfdcdd45bb4dc1af8887b3.svg";
export { ForwardRef as ReactComponent };